export const dtoRecovery = (data: any) => ({
  email: data.email.toLowerCase().trim(),
});
